module.exports = __webpack_public_path__ + "img/magnifier.01177106.svg";